export const SETTINGS_KEYS = {
  AUTH_USER: 'authUser',
} as const;

export type SettingsKey = typeof SETTINGS_KEYS[keyof typeof SETTINGS_KEYS];
